export const features = [
    {
        title: "Manajemen Antrian Digital",
        description: "Mengelola antrian pasien secara digital dengan sistem yang sederhana dan efisien.",
        icon: "/icons/clipboard.svg",
    },
    {
        title: "Layanan Bantuan 24/7",
        description: "Dukungan bantuan kapan saja untuk memastikan sistem berjalan lancar.",
        icon: "/icons/headphones.svg",
    },
    {
        title: "Manajemen Poli & Dokter",
        description: "Mengatur layanan poli dan dokter untuk setiap jenis antrian.",
        icon: "/icons/stetoscope.svg",
    },
    {
        title: "Akses Admin & Staf",
        description: "Hak akses terpisah untuk admin dan staf sesuai peran masing-masing.",
        icon: "/icons/team.svg",
    },
    {
        title: "Monitoring Antrian Real-time",
        description: "Memantau kondisi antrian secara langsung dan akurat setiap saat.",
        icon: "/icons/person.svg",
    },
    {
        title: "Pengaturan Jam Layanan",
        description: "Menyesuaikan jam operasional antrian sesuai jadwal klinik.",
        icon: "/icons/schedule.svg",
    },
];
